import { EditorSDK, EditorReadyOptions } from '@wix/platform-editor-sdk';
import { EditorScriptApi } from '../../api/api';
import { AddServicePage } from './add-pages/add-service-page';
import { AddCalendarPage } from './add-pages/add-calendar-page';
import { AddFormPage } from './add-pages/add-form-page';
import { AddEcomPages } from './add-pages/add-ecom-pages';
import { BaseAddPage } from './add-pages/base-add-page';
import { AddServiceListPage } from './add-pages/add-service-list-page';
import { Translations } from '../translations';
import { setBarStep } from '../progressbar-utils';
import {
  addBookingsPagesAsPanel,
  removeBookCheckoutPageOnEcom,
} from '../pages-panel-actions';
import { isADI } from '../editor-sdk-actions';

export const completeBookingsPages = async ({
  editorSDK,
  appToken,
  instance,
  editorScriptApi,
  editorOptions,
  displayStepsBar,
}: {
  editorSDK: EditorSDK;
  appToken: string;
  instance: string;
  editorScriptApi: EditorScriptApi;
  editorOptions: EditorReadyOptions;
  displayStepsBar?: {
    editorTranslation: Translations;
    currentStep: number;
  };
}) => {
  let currentStep = displayStepsBar?.currentStep || 0;
  const pageAdders: BaseAddPage[] = [
    new AddServiceListPage(editorSDK, appToken, instance),
    new AddServicePage(editorSDK, appToken, instance, editorScriptApi),
    new AddCalendarPage(editorSDK, appToken, instance),
    new AddFormPage(editorSDK, appToken, instance),
    new AddEcomPages(editorSDK, appToken, instance, editorScriptApi),
  ];

  for (const pageAdder of pageAdders) {
    try {
      if (displayStepsBar) {
        await setBarStep(
          editorSDK,
          appToken,
          displayStepsBar.editorTranslation,
          pageAdder.stepTranslate,
          currentStep,
        );
      }
      if (await pageAdder.shouldAddPage()) {
        await pageAdder.execute();
      }
      currentStep++;
    } catch (e) {
      const errorMessage = `${
        e?.message ? e.message : JSON.stringify(e)
      } - errorCode: OOI_MIGRATION, page: ${pageAdder.widgetName}`;
      throw new Error(errorMessage);
    }
  }

  try {
    await addBookingsPagesAsPanel(editorSDK, appToken);

    if (!isADI(editorOptions)) {
      await removeBookCheckoutPageOnEcom(editorSDK, appToken);
    }
  } catch (e) {
    const errorMessage = `${
      e?.message ? e.message : JSON.stringify(e)
    } - errorCode: FINISH_MIGRATION`;
    throw new Error(errorMessage);
  }

  console.log('migration completed successfully');
};
